import { WixComponentTypes } from '@wix/shoutout-email-model-v3';
import { formatFooter, getClassicFooterHtmlBlocks } from './utils';
const assertNever = (wixFooterType) => {
    throw new Error(`Unhandled case: ${wixFooterType}`);
};
export const getWixFooterContentByType = (wixFooterType, content) => {
    const footerContent = wixFooterType === WixComponentTypes.hopp
        ? { ...content, helpCenter: undefined, helpCenterUrl: undefined }
        : content;
    const styleOverrides = wixFooterType === WixComponentTypes.hopp
        ? {
            fontSize: '16px',
            lineHeight: '1em',
            paragraphLineHeight: '1em',
        }
        : undefined;
    const { addressLine, linksLine, dontReplyLine } = getClassicFooterHtmlBlocks({
        content: footerContent,
        styleOverrides,
    });
    switch (wixFooterType) {
        case WixComponentTypes.payments:
            return formatFooter([dontReplyLine, linksLine, addressLine]);
        case WixComponentTypes.paymentsBrazil:
            return getWixPaymentsBrazilFooter(content);
        case WixComponentTypes.studio:
            return getWixStudioFooter(content);
        case WixComponentTypes.classic:
            return formatFooter([dontReplyLine, addressLine, linksLine]);
        case WixComponentTypes.rise:
            return formatFooter([dontReplyLine, linksLine, addressLine]);
        case WixComponentTypes.hopp:
            return formatFooter([dontReplyLine, addressLine, linksLine]);
        default:
            return assertNever(wixFooterType);
    }
};
function getWixStudioFooter(content) {
    const { dontReply, helpCenter, helpCenterUrl, privacyPolicy, privacyPolicyUrl, termsOfUse, termsOfUseUrl, companyAddressLine, } = content;
    return `<div class="so-global-p1"><p style="text-align: left; line-height: 1.5em; font-size: 18px" class="so-global-p1"><span style="color: #2D2D2D"><span style="font-size: 18px"><span style="line-height: 1.5em"><span style="font-weight: bold">${dontReply}</span></span></span></span></p><p style="text-align: left; line-height: 0.5em; font-size: 8px" class="so-global-p1"><span style="color: #2D2D2D"><span style="font-size: 9px"><span style="line-height: 0.5em">&nbsp;</span></span></span></p><p style="text-align: left; line-height: 1.4em; font-size: 18px" class="so-global-p1"><a target="_blank" rel="noopener noreferrer" href="${helpCenterUrl}"><span style="color: #2D2D2D"><span style="font-size: 18px"><span style="line-height: 1.4em;border-right: 1px solid #2d2d2d;padding-right: 10px;">${helpCenter}</span></span></span></a><a target="_blank" rel="noopener noreferrer" href="${privacyPolicyUrl}"><span style="color: #2D2D2D"><span style="font-size: 18px"><span style="line-height: 1.4em;border-right: 1px solid #2d2d2d;padding-right: 10px;padding-left: 10px;">${privacyPolicy}</span></span></span></a><a target="_blank" rel="noopener noreferrer" href="${termsOfUseUrl}"><span style="color: #2D2D2D"><span style="font-size: 18px"><span style="line-height: 1.4em;padding-left: 10px;">${termsOfUse}</span></span></span></a></p><p style="text-align: left; line-height: 1.4em; font-size: 18px" class="so-global-p1"><span style="color: #2D2D2D"><span style="font-size: 18px"><span style="line-height: 1.4em;color: #2D2D2D">${companyAddressLine}</span></span></span></p></div>`;
}
const PAYMENTS_BRAZIL_COMMON_STYLE = 'color: #2D2D2D; font-size: 13px; line-height: 1.5';
const PAYMENTS_BRAZIL_LINK_STYLE = `${PAYMENTS_BRAZIL_COMMON_STYLE}; text-decoration: underline`;
const PAYMENTS_BRAZIL_SPACER = '<div style="height: 30px;">&nbsp;</div>';
function getWixPaymentsBrazilFooter(content) {
    const { paymentsBrazilCompliance, paymentsBrazilNeedHelp, paymentsBrazilAddressLine1, paymentsBrazilAddressLine2, paymentsBrazilAddressLine3, paymentsBrazilCompanyLine, paymentsBrazilTermsNotice, paymentsBrazilTermsOfServiceUrl, paymentsBrazilUnsupportedBusinessModelsUrl, paymentsBrazilVerificationRequirementsUrl, paymentsBrazilContactCustomerCareUrl, } = content;
    const getParagraph = (innerHtml, textAlign) => `<p style="text-align: ${textAlign}" class="so-global-p1"><span style="${PAYMENTS_BRAZIL_COMMON_STYLE}">${innerHtml}</span></p>`;
    const getBlock = (lines, textAlign) => formatFooter(lines.map((line) => getParagraph(line, textAlign)));
    const getLinkTag = (text, url) => `<a target="_blank" rel="noopener noreferrer" href="${url}" style="${PAYMENTS_BRAZIL_LINK_STYLE}">${text}</a>`;
    const replaceTransLinks = (text, urls) => {
        if (!text) {
            return undefined;
        }
        return urls.reduce((result, url, index) => result.replace(new RegExp(`<${index}>(.*?)</${index}>`, 'g'), (_match, linkText) => getLinkTag(linkText, url)), text);
    };
    const block1 = [
        replaceTransLinks(paymentsBrazilCompliance, [
            paymentsBrazilTermsOfServiceUrl || '',
            paymentsBrazilUnsupportedBusinessModelsUrl || '',
            paymentsBrazilVerificationRequirementsUrl || '',
        ]),
    ].filter((line) => Boolean(line));
    const block2 = [
        replaceTransLinks(paymentsBrazilNeedHelp, [
            paymentsBrazilContactCustomerCareUrl || '',
        ]),
    ].filter((line) => Boolean(line));
    const block3 = [
        paymentsBrazilAddressLine1,
        paymentsBrazilAddressLine2,
        paymentsBrazilAddressLine3,
        paymentsBrazilCompanyLine,
        replaceTransLinks(paymentsBrazilTermsNotice, [
            paymentsBrazilTermsOfServiceUrl || '',
        ]),
    ].filter((line) => Boolean(line));
    return [
        block1.length ? getBlock(block1, 'left') : '',
        block1.length && block2.length ? PAYMENTS_BRAZIL_SPACER : '',
        block2.length ? getBlock(block2, 'center') : '',
        block2.length && block3.length ? PAYMENTS_BRAZIL_SPACER : '',
        block3.length ? getBlock(block3, 'center') : '',
    ]
        .filter(Boolean)
        .join('');
}
//# sourceMappingURL=wix-footer-content.js.map